import { version } from '../package.json'

/**
 * The project's own details, in one place: where its source and issue tracker
 * are, what it is part of and who funds it. Pages, the feedback report and the
 * generated CI pipelines all read them from here.
 *
 * A deployment can point the source and the issue tracker elsewhere at build
 * time, with VITE_SOURCE_URL and VITE_ISSUES_URL (DEPLOYMENT.md).
 */

const env = import.meta.env as Record<string, string | undefined>

/** The EVERSE organisation on GitHub. */
export const EVERSE_GITHUB = 'https://github.com/EVERSE-ResearchSoftware'

const sourceUrl = env.VITE_SOURCE_URL || `${EVERSE_GITHUB}/DashVERSE`

export const PROJECT = {
  version,
  /** This application's source. */
  sourceUrl,
  /** Where defects and ideas go; a new issue is opened at `${issuesUrl}/new`. */
  issuesUrl: env.VITE_ISSUES_URL || `${sourceUrl}/issues`,
  licence: { name: 'Apache License 2.0', id: 'Apache-2.0' },
  everse: {
    name: 'EVERSE',
    fullName: 'the European Virtual Institute for Research Software Excellence',
    url: 'https://everse.software',
    consortiumUrl: 'https://everse.software/about/consortium/',
  },
  grant: {
    id: 'HORIZON-INFRA-2023-EOSC-01-02',
    url: 'https://ec.europa.eu/info/funding-tenders/opportunities/portal/screen/opportunities/topic-details/horizon-infra-2023-eosc-01-02',
  },
  /** resqui, the EVERSE quality pipeline, and the schema its reports follow. */
  resquiUrl: `${EVERSE_GITHUB}/QualityPipelines`,
  schemasUrl: `${EVERSE_GITHUB}/schemas`,
} as const
